<img
    [ngSrc]="logoPath()"
    alt="logo"
    class="cursor-pointer"
    [routerLink]="routeHome"
    width="171"
    height="30"
    priority />
